import { Box, MenuItem, Select, Typography } from "@mui/material";
import type { SelectChangeEvent } from "@mui/material";

import type { ResearchPortalDetail } from "../../store/reducers/portalsReducer";

export type SupplementalFilesMode = "all" | "excludeReleaseForms" | "none";

const supplementalFilesOptions: { value: SupplementalFilesMode; label: string }[] = [
  { value: "excludeReleaseForms", label: "Include all except release forms" },
  { value: "all", label: "Include all supplemental files" },
  { value: "none", label: "Do not include supplemental files" },
];

const fieldLabelSx = { color: "#606971", fontSize: "12px", fontWeight: 700, lineHeight: "18px", mb: "4px" };

interface PortalSelectionFieldsProps {
  portals: ResearchPortalDetail[];
  selectedPortal: ResearchPortalDetail | undefined;
  portalId: string;
  collectionId: string;
  supplementalFilesMode: SupplementalFilesMode;
  isSaving: boolean;
  onPortalChange: (event: SelectChangeEvent<string>) => void;
  onCollectionChange: (event: SelectChangeEvent<string>) => void;
  onSupplementalFilesModeChange: (mode: SupplementalFilesMode) => void;
}

export const PortalSelectionFields = ({
  portals,
  selectedPortal,
  portalId,
  collectionId,
  supplementalFilesMode,
  isSaving,
  onPortalChange,
  onCollectionChange,
  onSupplementalFilesModeChange,
}: PortalSelectionFieldsProps) => (
  <>
    <Box>
      <Typography sx={fieldLabelSx}>Portal</Typography>
      <Select size="small" value={portalId} onChange={onPortalChange} fullWidth displayEmpty>
        {portals.map((portal) => (
          <MenuItem key={portal._id} value={portal._id}>
            {portal.title} ({portal.status})
          </MenuItem>
        ))}
      </Select>
    </Box>
    <Box>
      <Typography sx={fieldLabelSx}>Collection</Typography>
      <Select
        size="small"
        value={collectionId}
        onChange={onCollectionChange}
        disabled={!selectedPortal?.collections.length}
        fullWidth
        displayEmpty
      >
        {!selectedPortal?.collections.length && (
          <MenuItem value="" disabled>
            No collections
          </MenuItem>
        )}
        {selectedPortal?.collections.map((collection) => (
          <MenuItem key={collection._id} value={collection._id}>
            {collection.title}
          </MenuItem>
        ))}
      </Select>
    </Box>
    <Box>
      <Typography sx={fieldLabelSx}>Supplemental files</Typography>
      <Select
        size="small"
        value={supplementalFilesMode}
        onChange={(event: SelectChangeEvent<SupplementalFilesMode>) =>
          onSupplementalFilesModeChange(event.target.value as SupplementalFilesMode)
        }
        disabled={isSaving}
        fullWidth
      >
        {supplementalFilesOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
    {selectedPortal && selectedPortal.collections.length === 0 && (
      <Typography sx={{ color: "#C94343", fontSize: "13px", lineHeight: "20px" }}>
        Add a collection to this portal first.
      </Typography>
    )}
  </>
);
